function copyToClipboard(){
   var dummy = document.createElement('input'),
       text = window.location.href;

  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);
  
  $('.copy-link').addClass('active');
  setTimeout(function(){ 
    $('.copy-link').removeClass('active');
  }, 2000);
}

// book events popup
$(document).ready(function(){
  var oldval = localStorage.getItem('currencyWidget');
  if (oldval !== '') {
    var interval = setInterval(function() {
      if (oldval !== localStorage.getItem('currencyWidget')) {
        clearInterval(interval);
        window.location.reload();
        return false;
      }
    }, 100)
    }else{
      var interval = setInterval(function() {
        oldval =localStorage.getItem('currencyWidget');
        clearInterval(interval);
      }, 100)
      }
  
  var currencyValue = 0;
  function currency() {
    if ($('.Launch__Text-sc-1xjd9ll-5').length)
    {
      var currencyTitle = $('.Launch__Text-sc-1xjd9ll-5').text();
      if(currencyTitle == 'MYR'){
        $('.main_banner .main_slideinr').each(function(){
          var country = $(this).data('id');
          if(currencyTitle == country){
            $(this).siblings().hide();
            $(this).show();
          }
        });
        $('.sale_slider .sale-slide-wrap').each(function(){
          var sale_banner = $(this).data('id');
          if(currencyTitle == sale_banner){
            $(this).show();
            $(this).siblings().hide();
          }
        });
      }else{
        $('.main_banner .main_slideinr').each(function(){
          var country = $(this).data('id');
          if(currencyTitle == country){
            $(this).siblings().hide();
            $(this).show();
          }
        });
        $('.sale_slider .sale-slide-wrap').each(function(){
          var sale_banner = $(this).data('id');
          if(currencyTitle == sale_banner){
            $(this).show();
            $(this).siblings().hide();
          }
        }); 
      }
    }
    else {
      currencyValue++;
      setTimeout(function(){currency();},100);
    }
  }
  currency();
  
  $('.product-page-addtocart').on('click',function(){
    setTimeout(function(){
      location.reload(true);
    }, 2500);
  });
  
  $(document).on('click','.booking-btn',function(){
    var id = $(this).parents('.book-event-box').attr('data-id');
    $('.book-events-get-thanks').attr('data-id',id);
  });
  
  $(document).on('click','.book-events-btn',function(e){
    e.preventDefault();
    $('body').addClass('book-events-active');
    $('.book-events-popup-wrap').show();
    $('.book-events-thanks-block').hide();
    
    var id = $(this).parents('.book-events-slider li').data('id');
    var event_title = $(this).parents('.book-events-slider li').data('event_title');
    var event_date = $(this).parents('.book-events-slider li').data('event_date');
    var event_time = $(this).parents('.book-events-slider li').data('event_time');    
    var event_location = $(this).parents('.book-events-slider li').data('event_location');
    var date_time = event_date +' '+event_time;
    
    $('.book-events-thanks-block .wc_js_calendar .wc_calendar_date').text(date_time);
    $('.book-events-thanks-block .wc_js_calendar .wc_calendar_title').text(event_title);
    $('.book-events-thanks-block .wc_js_calendar .wc_calendar_location').text(event_location);

    $('.book-events-get-thanks').attr('data-id',id);
  });

  $(document).on('click','.book-events-popup-overly,.book-events-popup-close,.book-events-not-subscribe',function(){
    $('body').removeClass('book-events-active');
    $('.book-events-get-thanks').removeAttr('data-id');
  });
  
  $(document).on('click','.book-events-get-thanks',function(){
    
    
    if($(this).hasClass('guest-user')){
      var customerEmail = $('#book-event-customer-id').val();
    }else{
      var customerEmail = $(this).attr('data-mail');
    }
    var ListID = $(this).attr('data-id');
    
    if(customerEmail.length > 0){
      if (validateEmail(customerEmail)) {
        // Valide Email Address
      } else {
        alert('Please enter valid email address');
        return false;
      }
    }else{
      alert('Please enter Email Address');
      return false;
    }
    
    if(ListID != 'null'){
      var testdata = {
        listid: ListID,
        email: customerEmail
      }
      $.ajax({
        url: 'http://app.bookxcess.com/event/api/klaviyo-integration',
        method: 'POST',
        data: testdata,
        success: function(e){
          $('.book-events-popup-wrap').hide();
          $('.book-events-thanks-block').show();
          $('.book-events-thanks-block p').text(e.message);
        },
        error: function(){
          console.log('error occured on Klaviyo custom api call...');
        }
      });
//       var settings = {
//         "async": true,
//         "crossDomain": true,
//         "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
//         "method": "POST",
//         "headers": {
//           "content-type": "application/x-www-form-urlencoded",
//           "cache-control": "no-cache"
//         },
//         "data": {
//           "g": ListID,
//           "email": customerEmail
//         }
//       }

//       $.ajax(settings).done(function (response) {
//         console.log('response', response)
//         if(response.data.is_subscribed == false){
//           console.log('true part called')
//           $('.book-events-popup-wrap').hide();
//           $('.book-events-thanks-block').show();
//         }else{
//           console.log('false part called')
//           $('.book-events-popup-wrap').hide();
//           $('.book-events-thanks-block').text('you have already booked this event');
//           $('.book-events-thanks-block').show();
//         }
//       });
      
      
    }
  });
});
function validateEmail(email) {
  var pattern = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
  return $.trim(email).match(pattern) ? true : false;
}
// book events popup end

$(document).on('click','.success-popup-close,.success-popup-overly',function(){
  $('body').removeClass('success-active');
  $('body').removeClass('fail-active');
});

// notify me popup
$(document).ready(function(){
  $(document).on('click','.notify_btn',function(){
    $('body').addClass('notify_me_active');
    var product_id = $(this).parents('.product_grid').data('id');
    var variant_id = $(this).parents('.product_grid').data('variant');
    $('.notify-me-popup .notify-me-thanks-btn').attr({'data-id':product_id,'data-variant':variant_id});
    
    var search_productId = $(this).parents('.predictive-search__list-item').data('id');
    var search_variantId = $(this).parents('.predictive-search__list-item').data('variant');
    $('.notify-me-popup .notify-me-thanks-btn').attr({'data-id':search_productId,'data-variant':search_variantId});
  });

  $(document).on('click','.notify-me-popup-overly,.notify-me-popup-close,.notify-me-cancel-btn',function(){
    $('body').removeClass('notify_me_active');
    var product_id = $(this).parents('.notify-me-popup').data('id');
    var variant_id = $(this).parents('.notify-me-popup').data('variant');
    $('.notify-me-thanks-btn').removeAttr('data-id').removeAttr('data-variant');
  });
  
  $(document).on('click','.notify-me-thanks-btn',function(){
    $('body').removeClass('notify_me_active');
  });
});
// notify me popup end

// custom checkout
$(document).ready(function(){
  
//   $('.customCheckout').on('click',function(e){
//     e.preventDefault();
//     var list_item= []
//     $('.cart_cls .cartp_items .cart_checkbox input').each(function(){
//       if(!$(this).is(':checked')){
//         list_item.push(0) 
//       }
//       else{
//         list_item.push(parseInt($(this).closest('.cartp_items').find('.quantity__input').val())) 
//       }
//     });
// //     console.log('list_item',list_item);
//     $.ajax({
//       type: 'POST',
//       url: '/cart/update.js',
//       data: {updates: list_item},
//       success: function(data){
// //         console.log('wc------success');
//         window.location.href = '/checkout';
//       },
//       error: function(){
//         alert("error occured")
//       }
//     });
//   });
});
// end custom checkout


$(document).on('click','.promotion-tab-item a',function(e){
  e.preventDefault();
  $(this).addClass('active');
  $(this).parents('.promotion-tab-item li').siblings().find('a').removeClass('active');
  var tab = $(this).parents('li').index();
  $('.promotion-tabs-slider').slick('slickGoTo', tab);
});

$(document).on('click','.promotion-tabs-slider .slick-dots li',function(){
  var dot = $(this).index();
  $('.promotion-tab-item li').each(function(){
    var tab = $(this).index();
    if(dot == tab){
      $(this).find('a').addClass('active');
      $(this).siblings().find('a').removeClass('active');
    }
  });
});

function memberText(){

  var memberTextValue = 0;
  function memberheight(){
    if ($('.pro_grid_btm .member_text').length)
    {
      var height = 0;
      $('.pro_grid_btm .member_text').each(function(){
        if($(this).height() > height){
          height = $(this).height();
        }
      });
      $('.pro_grid_btm .member_text').height(height);
    }
    else{
      memberTextValue++;
      setTimeout(function(){ memberheight(); }, 100);
    }
  }
  memberheight();
  
//   var promotionTitle = 0;
//   $('.promotion-tabs-slider h3').each(function(){
//     if($(this).height() > promotionTitle){
//       promotionTitle = $(this).innerHeight();
//     }
//   });
//   $('.promotion-tabs-slider h3').height(promotionTitle);
  
  var donationTitle = 0;
  $('.donation-make-wish-pro-block h2').each(function(){
    if($(this).height() > donationTitle){
      donationTitle = $(this).innerHeight();
    }
  });
  $('.donation-make-wish-pro-block h2').height(donationTitle);
  
//   event page 
  var eventheight = 0;
  $('.events-product-nav-block .col .events-product-nav h2').each(function(){
    if($(this).height() > eventheight){
      eventheight = $(this).innerHeight();
    }
  }); 
  $('.events-product-nav-block .col .events-product-nav h2').height(eventheight);
  
//   var eventtitle = 0;
//   $('.book-events-content h2').each(function(){
//     if($(this).height() > eventtitle){
//       eventtitle = $(this).innerHeight();
//     }
//   });
//   $('.book-events-content h2').height(eventtitle);
  
  
   $('.book-events-content h2').matchHeight({});

  
//   var eventdesc = 0;
//   $(' .book-events-desc').each(function(){
//     if($(this).height() > eventdesc){
//       eventdesc = $(this).innerHeight();
//       console.log('promotionTitle',eventdesc);
//     }
//   });
//   console.log('promotionTitle------',eventdesc);
//   $('.book-events-desc').height(eventdesc);

//   header
//   var header = $('.ba_anno_outer').innerHeight() + $('#shopify-section-header').innerHeight();
//   $('.cart-side-panel').css('top',header);
//   var width = $(window).width();
//   if(width <= 991){
//     var header = $('.ba_anno_outer').innerHeight() + $('#shopify-section-header').innerHeight();
//     $('.cart-side-panel').css('top',header);
//   }
  
//   pagination
  var first = $('.collection_gridcls .pro_listcolmn').first().find('.pro_spancount').text();
  var last = $('.collection_gridcls .pro_listcolmn').last().find('.pro_spancount').text();
  $('.collection_count .pro__listinr').find('.paginate_start').text(first);
  $('.collection_count .pro__listinr').find('.paginate_last').text(last);
  
}

function productImg(){
  var width = $(window).width();
  if(width <= 575 ){
    $(document).on('click','.product-view-all-img span',function(){
      $('body').removeClass('open-img-popup');
      $('.slider-nav').slick('unslick');
      $('.slider-nav').addClass('active');
      $('.product-view-all-img span').addClass('active');
    });
    $(document).on('click','.product-view-all-img span.active',function(){
      $('.slider-nav').slick('refresh');
      $(this).removeClass('active');
    });
    
    $('.product-view-all-img span').hide();
    var count = $('.slider-nav li').length;
    if(count >= 3){
      $('.product-view-all-img span').show();
    }
  }
}


$(window).on('load',function(){
  productImg();
  memberText();
});

$(window).resize(function(){
  productImg();
  memberText();
});

$(document).ready(function(){
  productImg();
  memberText();
  $(window).scroll(function(){ 
    if ($(this).scrollTop() > 300) { 
      $('#scroll').fadeIn(); 
    } else { 
      $('#scroll').fadeOut(); 
    } 
  }); 
  $('#scroll').click(function(){ 
    $("html, body").animate({ scrollTop: 0 }, 2000); 
    return false; 
  }); 
});

$(window).on('load',function(){
  var cd_height = $('.cd_item').innerHeight() + $('.cd_footer').innerHeight();
  $('.cd_block').css('height', $(window).height() - cd_height + 'px');
});
$(window).resize(function(){
  var cd_height = $('.cd_item').innerHeight() + $('.cd_footer').innerHeight();
  $('.cd_block').css('height', $(window).height() - cd_height + 'px');
});
$(document).ready(function(){
  //   cart drawer
  $(".cartBtn").on('click',function(){
    $("body").toggleClass("CartOpen");
    var val = $(this).find('.cart_item_cls').text();
    $('.cart-count-block').text(val);
    var cd_height = $('.cd_item').innerHeight() + $('.cd_footer').innerHeight();
    $('.cd_block').css('height', $(window).height() - cd_height + 'px');
    return false;
  });
  $(".cart_overly,.cd_close").on('click',function(){
    $(".cart_item").hide();
    $("body").removeClass("CartOpen");
    return false;
  });

  $('body').click(function(e){
    var container = $(".cart-side-panel");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      $('body').removeClass("CartOpen");
    }
  });
  
  $('.events-video .video_btn').on('click',function(){
    $(this).hide();
    $(this).parents('.events-video').find('.video-section__media img').toggle();
  });

  //   loadmore
  $(".interest-item-wrap .intrest_boxlist .col").hide();
  $(".interest-item-wrap .intrest_boxlist .col").slice(0,9).show();
  $("body").on('click touchstart', '.interest-loadmore-block a', function (e) {
    e.preventDefault();
    $(".interest-item-wrap .intrest_boxlist .col:hidden").slice(0, 3).slideDown();
    if ($(".interest-item-wrap .intrest_boxlist .col:hidden").length == 0) {
      $(".interest-loadmore-block a").hide();
    }
    $('html,body').animate({
      scrollTop: $('.interest-item-wrap .intrest_boxlist').offset().top
    }, 1000);
  });
  
//   end loadmore
  $('.mobile-page-menu ul').slideUp();
  $('.mobile-page-menu button').on('click',function(){
    $(this).parents('.mobile-page-menu').toggleClass('active');
    $(this).parents('.mobile-page-menu').find('ul').slideUp();
    $(this).parents('.mobile-page-menu.active').find('ul').slideDown();
 });
  
  $("#attachment").on("change", function () {
    if(this.files[0].size > 2000000){
      $(this).val('');
      $(this).next('p').css('color','red');
    }else{
      $('.fileinputs .field__input').after(this.files[0].name);
      $(this).next('p').css('color','#000');
    }
  });
 
  if($('.events-banner-slider').length>0){
    $('.events-banner-slider').slick({
      infinite: true,
      slidesToShow:1,
      slidesToScroll:1,
      arrows:true,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M20.584 13L5.41733 13" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 20.584L5.41667 13.0007L13 5.41732" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M5.41602 13L20.5827 13" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 5.41602L20.5833 12.9993L13 20.5827" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      dots:true,
      autoplaySpeed: 4000,
      appendDots: $('.slie_arw_inr'),
      customPaging: function(slick, index) {
        return ('<a href="" aria-label="' + ( index + 1) + '" data-slide-number="' + index +'"></a>');
      }
    });
    $('.slider_autoplay').on('click', function() {
      $('.events-banner-slider').slick('slickPlay');
      $(this).removeClass('active');
      $('.slider_play').addClass('active');
    });
    $('.slider_play').on('click', function() {
      $('.events-banner-slider').slick('slickPause');
      $(this).removeClass('active');
      $('.slider_autoplay').addClass('active');
    });
  }
  
  $('.promotion-slider').slick({
    dots: true,
	arrows:false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
  $('.promotion-tabs-slider').slick({
    dots: true,
	arrows:false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
  $('.ba_anno_center ul').slick({
    dots: false,
    arrows:false,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings:{
//           speed: 5000,
//           autoplay: true,
//           autoplaySpeed: 0,
//           variableWidth: true,
//           cssEase: 'linear',
//           swipeToSlide: true,
//           centerMode: true,
//           focusOnSelect: true,
//         }
//       }
//     ]
  });
  
  var slider_count = $('.video-slider-block').data('id'); 
  $('.video-slider-block').slick({
    dots: false,
	arrows:true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M20.584 13L5.41733 13" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 20.584L5.41667 13.0007L13 5.41732" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M5.41602 13L20.5827 13" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 5.41602L20.5833 12.9993L13 20.5827" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    infinite: true,
    slidesToShow: slider_count,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint:768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  
  $('.events-collection-slider').slick({
    dots: false,
	arrows:true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M20.584 13L5.41733 13" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 20.584L5.41667 13.0007L13 5.41732" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M5.41602 13L20.5827 13" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 5.41602L20.5833 12.9993L13 20.5827" stroke="#EE7656" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint:1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint:768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
   //   product page quantity box
//   $('.quantity__button[name="minus"]').on('click' , function(){
//     var input_val = $(this).parents('.quantity').find('input[name="quantity"]');
//     var value = parseInt(input_val.val());
//     if(value > 1){
//       input_val.val(value - 1);
//       console.log('minus',value,'input_val',input_val);
//     }
//   });
//   $('.quantity__button[name="plus"]').on('click' , function(){
//     var input_val = $(this).parents('.quantity').find('input[name="quantity"]');
//     var value = parseInt(input_val.val());
//     input_val.val(value + 1);
//     console.log('plus',value,'input_val',input_val);
//   });
  
  $('.intrest_boxlist .intrestboxinr input').change(function(){
//     alert();
    if ($(this).is(":checked")){
      $(this).parents('.intrestboxinr').addClass('active');
    }else{
      $(this).parents('.intrestboxinr').removeClass('active');
    }
  });
  
//   interest checkbox
  $('.interest-item-wrap .intrestboxinr a input').change(function(){
    if ($(this).is(":checked")){
      $(this).parents('.intrestboxinr').find('a').addClass('active');
    }else{
      $(this).parents('.intrestboxinr').find('a').removeClass('active');
    }
  });
});

$(window).on('load',function(){
  var h = $('.product-overview-sec').height();
  if(h < 340){
    $('.product-overview-sec span').hide();
  }
});

/* ====================  product page ====================== */
$(document).ready(function(){
  
  
  //   menu slider
  (function() {
    'use strict';
    const breakpoint = window.matchMedia( '(min-width:992px)' );
    let mySwiper;
    const breakpointChecker = function() {
      if ( breakpoint.matches === true ) {
        if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
        $('.main_navlist').removeClass('swiper-container');
        return;
      } else if ( breakpoint.matches === false ) {
        return enableSwiper();
      }
    };
    const enableSwiper = function() {
      $('.main_navlist').addClass('swiper-container');
      mySwiper = new Swiper ('.main_navlist', {
        loop: false,
        slidesPerView:"auto",
        spaceBetween: 1,
        navigation: {
          nextEl: ".next_menu",
          prevEl: ".prev_menu",
        },
      });
    };
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  })();
  //   menu slider
  
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Previous"><svg id="SVGDoc" width="29" height="49" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" viewBox="0 0 29 49"><defs></defs><desc>Generated with Avocode.</desc><g><g><title>&amp;lt;Path&amp;gt;</title><path d="M15.9715,0.0306v0l-15.596,24.04v0l15.595,24.04v0h12.591v0l-15.594,-24.04v0l15.595,-24.04v0z" fill="var(--color-accest1)" fill-opacity="1"></path></g></g></svg></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next"><svg id="SVGDoc" width="29" height="49" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" viewBox="0 0 29 49"><defs></defs><desc>Generated with Avocode.</desc><g><g><title>&amp;lt;Path&amp;gt;</title><path d="M0.4229,0.8499v0h12.663v0l15.596,23.971v0l-15.596,23.972v0h-12.663v0l15.668,-23.972v0z" fill="var(--color-accest1)" fill-opacity="1"></path></g></g></svg></button>',
    fade: true,
    infinite: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    arrows: false,
    infinite: true,
//     centerMode: true,
    focusOnSelect: true,
    vertical:true
  });

  $('.slider-for').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.product__media-item').each(function () {
      var youtubePlayer = $(this).find('iframe').get(0);
      if (youtubePlayer) {
        youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
    });
  });
  
  $('.product-overview-sec span').on('click',function(){
    var h = $(this).parents('.product-overview-sec').height();
    if(h > 340){
      if($(this).parent('.product-overview-sec').hasClass('active')){
        $(this).parent('.product-overview-sec').removeClass('active');
      }else{
        $('.product-overview-sec').removeClass('active');
        $(this).parent('.product-overview-sec').addClass('active');
      }
    }
  });
  $('.product-view-all-img span').on('click',function(){
    $('body').addClass('open-img-popup');
    $('.product-img-popup').show();
  });
  $('.product-img-popup-close').on('click',function(){
    $('body').removeClass('open-img-popup');
    $('.product-img-popup').hide();
  });

  $('.img-popup-item .navbar-img-popup li').on('click',function(){
    var nav_img = $(this).find('img').attr('src');
    $('.main-img-popup li img').each(function( index ) {
      var main_img = $(this).attr('src');
      if(nav_img == main_img){
        $(this).parents('.product__media-item').addClass('active');
        $(this).parents('.product__media-item').siblings().removeClass('active');
      }
    });
  });

  

// -------------moved this code to custom.js------------------
//   $(document).on('click','.product-gift-btn',function(e){
//     $('#gift-inner-block-items').empty();
//     e.preventDefault();
//     $.getJSON('https://bookxcess-estore.myshopify.com/cart.json', function(e){
//       var items_count= e.items
//       console.log(items_count.length)
//       for(var count= 1; count <= items_count.length; count++){
//         var inner_html = '<div class="gift-inner-wrap"><input type="checkbox" id="gift-wrapping-'+count+'" value="'+items_count[count-1].title+'" class="product-gift-wrap_'+count+'" data-line-item="'+count+'" /><label for="gift-wrapping-'+count+'">'+items_count[count-1].title+'</label></div>'
//         $('#gift-inner-block-items').append(inner_html)
//       }
//       $("#gift-wrapping-1, #gift-wrapping-2").prop('checked', true);
//     });

//     var id = $(this).attr('data-id');
//     var data_line = $(this).parents('.gift_line_item').data('line-item');
//     $('.product-gift-item').attr('data-line-item',data_line);
//     $('.gift-popup-submit').attr('id',id);
//     $('body').removeClass('CartOpen')
//     $('body').addClass('gift-block-active');
//     $(".product-gift-block").show();
//   });
//  -------------moved this code to custom.js------------------
  
  
  
//   $('.product-gift-btn').on('click',function(){
//     $('body').addClass('gift-block-active');
//     $(".product-gift-block").show();
//   });
  
//  -------------moved this code to custom.js------------------
  $(".product-gift-overly,.product-gift-popup-close").on('click',function(){
    $(".product-gift-block").hide();
    $('body').removeClass('gift-block-active');
    $('.product-gift-item').attr('data-line-item','');
  });

//  -------------moved this code to custom.js------------------
});

$(document).ready(function(){
  function addLabelSection(){
    if ($('ul.cbb-frequently-bought-selector-list li').length)
    {
      $('ul.cbb-frequently-bought-selector-list li').each(function( index ) {
        var wc_id = $(this).find('input').attr('id');
        $(this).find('input').after('<label class="wc_label_added" for='+wc_id+'></label>')
      });
    }
    else {
      setTimeout(function(){ addLabelSection() }, 100);
    }
  }
  addLabelSection();


  //   ===========flash sale=======

  
  
  if( $('.wc_flash_sale').length > 1){
    var date_array=[];
    var current_d = new Date();
    $('.wc_flash_sale').each(function(e){    
      var exp_date= new Date($(this).data('expire_date'));
      date_array.push(exp_date);
    })
    var exp_date_1 = date_array[0]
    var exp_date_2 = date_array[1]

    if(exp_date_1 > current_d && exp_date_2 > current_d){
      if(exp_date_1 > exp_date_2){
        $(".wc_flash_sale[data-expire_date='" + exp_date_1 + "']").hide();
      }else if(exp_date_1 < exp_date_2 || exp_date_2 < current_d){
        $(".wc_flash_sale[data-expire_date='" + exp_date_2 + "']").hide();
      }
    }else{
      if( exp_date_1 < current_d){
        $(".wc_flash_sale[data-expire_date='" + exp_date_1 + "']").hide();  
      }
      if( exp_date_2 < current_d){
        $(".wc_flash_sale[data-expire_date='" + exp_date_2 + "']").hide();  
      }
    }

  }else {
    var expdate = $('.wc_flash_sale').data('expire_date')
    var current_d = new Date();
    if( expdate < current_d){
      $(".wc_flash_sale[data-expire_date='" + expdate + "']").hide();  
    }
  }
  
  if(exp_date_1 == current_d){
    function checktimeout(){
   	  var xx= $('#shopify-section-template--14931565641934__1631526421d6dae9e3 .flash_sale_countdown').data('count-down')
      setTimeout(checktimeout, 1000);
      if(xx <= 0){
        $('#shopify-section-template--14931565641934__1631526421d6dae9e3 .wc_flash_sale').hide();
      }
    }
    checktimeout();  
  }

});


// Country wise banner change

// Country wise banner change


$(document).ready(function(){
  if (localStorage.getItem("ipstack_info") === null) {
    $.getJSON('http://api.ipstack.com/check?access_key=8ab936aed7a07b643a5ad24cde9847bc', function(e){
//       console.log('e', e);

      var city_name = e.city
      var state_name = e.region_name
      //     var country_code = e.country_code
      var zip_code = e. zip 
      var country_name = e.country_name
      var currency_code = e.currency.code
      var default_code= 'MYR';
      var available_country=  ['MYR', 'AED', 'AUD', 'BDT', 'GBP', 'IDR', 'LKR', 'MMK', 'PHP', 'SGD', 'THB', 'TWD', 'USD']
      var ip_info = {
        "city_name": city_name,
        "state_name": state_name,
        "currency_code": currency_code,
        "country_name": country_name,
        "zip_code": zip_code
      }
      var dummy_info ={
        "city_name": 'Selangor',
        "state_name": 'Shah Alam',
        "currency_code": 'MYR',
        "country_name": 'Malaysia',
        "zip_code": '40400'
      }

      if ($.inArray(currency_code, available_country) != -1){
        localStorage.setItem("ipstack_info", JSON.stringify(ip_info));
        conversionBearAutoCurrencyConverter.convertPricesOnPage();
      }else{
        localStorage.setItem("ipstack_info", JSON.stringify(dummy_info));
      }
    });
  }else{
    console.log('No need call an API')
  }
});

// $(document).ready(function(e){
//   setTimeout(function(e){
//   var current_currncy = JSON.parse(localStorage.getItem("ipstack_info"));
//     console.log('current_currncy',current_currncy);
//     $('.comm_s_full').each(function(e){
//       if($(this).data('id') != current_currncy.currency_code){
//         $(this).addClass('nba_full_hide');
//       }
//     });
//   }, 200);
// });

var contantValue = 0;
function recursive() {
  if (JSON.parse(localStorage.getItem("ipstack_info")) != null)
  {
    var current_currncy = JSON.parse(localStorage.getItem("ipstack_info"));
//     console.log('current_currncy',current_currncy);
    $('.comm_s_full').each(function(e){
      if($(this).data('id') != current_currncy.currency_code){
        $(this).addClass('nba_full_hide');
      }
    });
    $('.nss_block').each(function(e){
      if($(this).data('id') != current_currncy.currency_code){
        $(this).addClass('nba_full_hide');
      }
    });
  }
  else {
    contantValue++;
    setTimeout(function(){ recursive(); }, 100);
  }
}
recursive();


var priceValue = 0;
function price(){
  if($('.pro_grid_btm .pro_grid_price').length)
  {
    setTimeout(function(){
      var priceHeight = 0;
      $('.pro_grid_btm .pro_grid_price').each(function(){
        if($(this).height() > priceHeight){
          priceHeight = $(this).innerHeight();
        }
      });
      $('.pro_grid_btm .pro_grid_price').height(priceHeight);
    },5000);
  }
  else {
    priceValue++;
    setTimeout(function(){ price(); }, 100);
  }
}
price();

var grid_cont = 0;
function gridContent(){
  if($('.pro_grid_btm h5').length)
  {
    setTimeout(function(){
      var grid_con_height = 0;
      $('.pro_grid_btm h5').each(function(){
        if($(this).height() > grid_con_height){
          grid_con_height = $(this).innerHeight();
        }
      });
      $('.pro_grid_btm h5').height(grid_con_height);

      $('.pro_grid_btm h5')
      .mouseover(function() {
        $(this).height("auto");
      })
      .mouseout(function() {
        var h = $(this).parents('.nhome_collslider').find('.pro_grid_btm .pro_gridmeta h5').innerHeight();
        $(this).height(h);
      });

    },5000);
  }
  else {
    grid_cont++;
    setTimeout(function(){ gridContent(); }, 100);
  }
}
gridContent();

$(document).ready(function(){
  recursive();
  price();
  gridContent();
});
$(window).on('load',function(){
  price();
  gridContent();
});
$(window).resize(function(){
  price();
  gridContent();
});

setTimeout(function(e){
  var ip_information = JSON.parse(localStorage.getItem('ipstack_info'));
//   console.log('Ip setp')
  $('.block-cart-header.active .cart-country').text(ip_information.state_name);
}, 5000);




// $(document).ready(function(e){
//   $.getJSON('http://api.ipstack.com/check?access_key=8ab936aed7a07b643a5ad24cde9847bc', function(e){
//     var country_code = e.country_code
//     var country_name = e.country_name
//     var currency_code = e.currency.code
//     console.log('country_code', country_code)
//     console.log('country_name', country_name)
//     console.log('currency_code', currency_code)
//   })
// })


//   ===========flash sale=======



// const youtubeKey = 'AIzaSyCaZfHU9M6qFKzyw8SwjV_oCxxnWuuqPro';
// const youtubeUser = 'UCA00dU7ihmJdqey0NO443bA';
// const subCount = document.getElementById('subCount');

// let getSubscribers = () => {

//   fetch(`https://www.googleapis.com/youtube/v3/channels?part=statistics&id=${youtubeUser}&key=${youtubeKey}`)
//   .then(response => {
//     return response.json()
//   })
//   .then(data => {
//     console.log(data);
//     subCount.innerHTML = data["items"][0].statistics.viewCount;
//   })

// }

// getSubscribers();
// if ($(window).width() < 576) {
//   recursive()
//   function recursive(){
//     var optionsLength = $('.cbb-also-bought-slider-list .cbb-also-bought-product').length;
//     if(optionsLength > 0){
//       $('.cbb-also-bought-product-name').matchHeight({});
//       return false;
//     }else{
//       setTimeout(function(){
//         recursive();
//       },300);
//     }
//   }
// }

